import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.scss'],
})
export class ProductCategoryComponent {
  @Input() alternativeText: string;
  @Input() name: string;
  @Input() imgSource = '';
  @Output() clickCategory = new EventEmitter();
  constructor() {}
  onClickCategory() {
    this.clickCategory.emit();
  }
}
